<template>
  <v-container>
    <AsyncComponent
      :request-status="requestStatus"
      error-message="klientide laadimine ebaõnnestus"
    >
      <div>
        <v-row>
          <v-col><h1>Kogukonnas elamise päeva kokkuvõte</h1></v-col>
          <v-col cols="2">
            <DatePicker v-model="date" label="kuupäev" />
          </v-col>
        </v-row>
        <div v-for="client in clients" :key="client.id">
          <v-row dense>
            <p
              v-for="error in client.validationErrors"
              :key="error.id"
              class="validationError"
            >
              {{ error }}
            </p>
          </v-row>
          <v-row dense>
            <v-col cols="3">
              <h3>{{ client.fullName }}</h3>
            </v-col>
            <v-col class="pr-4" cols="auto">
              <!--
              The order of buttons in `btn-toggle` much match the
               order of elements in `ScheduleAccomplishmentStatus`:
              `btn-toggle` returns a number as `v-model` value
              which needs to map to the numeric value of `ScheduleAccomplishmentStatus`
              -->
              <v-btn-toggle v-model="client.scheduleAccomplished" dense>
                <v-btn>
                  <span style="color: green; font-size: small"
                    >Päevaplaan<br />täidetud</span
                  >
                </v-btn>
                <v-btn>
                  <span style="color: red; font-size: small"
                    >Päevaplaan<br />puudulik</span
                  >
                </v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col>
              <v-textarea v-model="client.daySummary" rows="1" />
            </v-col>
          </v-row>
        </div>
        <v-row align="end" dense>
          <v-col class="text-right" cols="12">
            <v-btn
              :disabled="!saveBtnEnabled"
              :loading="savePending"
              color="primary"
              @click="processSave"
            >
              Salvesta
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </AsyncComponent>
  </v-container>
</template>

<script>
import { ApiRequestStatus } from '@/dataAccess/ApiRequestStatus'
import DatePicker from '@/components/DatePicker'
import CommunityLivingClient from '@/dataAccess/dto/CommunityLivingClient'
import AsyncComponent from '@/components/AsyncComponent'
import { getCurrentISODateString } from '@/utils/datetime'

export default {
  components: { DatePicker, AsyncComponent },
  data() {
    return {
      date: getCurrentISODateString(),
      clients: [],
      requestStatus: ApiRequestStatus.ofLoading(),
      savePending: false
    }
  },
  computed: {
    saveBtnEnabled() {
      return this.clients.some(client => client.isDataEntered())
    }
  },
  async created() {
    ;[
      this.clients,
      this.requestStatus
    ] = await CommunityLivingClient.getAllFromApi()
  },
  methods: {
    async processSave() {
      // Run all validators
      const validationResults = this.clients.map(client => client.validate())
      // If there are validation errors, do not proceed.
      //  The errors are collected into a reactive property and automatically displayed in the UI.
      if (!validationResults.every(result => result)) return

      // POST Actions
      let message
      try {
        this.savePending = true
        await CommunityLivingClient.postActions(this.clients, this.date)
        message = 'Tegevused on salvestatud'
        this.resetForm()
      } catch (e) {
        console.error(e.response)
        message = 'Tegevuste salvestamine ebaõnnestus, palun proovi uuesti'
      } finally {
        this.savePending = false
      }
      this.$eventBus.$emit('notification', message)
    },
    resetForm() {
      this.clients.forEach(client => {
        client.scheduleAccomplished = null
        client.daySummary = ''
      })
    }
  }
}
</script>

<style>
.validationError {
  color: red;
  font-size: small;
}
</style>
